var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBarSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.888 0a8.888 8.888 0 0 1 7.02 14.337l3.767 3.766a1.11 1.11 0 1 1-1.572 1.572l-3.766-3.766A8.888 8.888 0 1 1 8.887 0Zm0 2.222a6.666 6.666 0 1 0 0 13.331 6.666 6.666 0 0 0 0-13.331"
})));
export default SvgIconBarSearch;